// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"dashboard":"aee4ac19aba8e0b75a1a","Content_js_Views_DayMenu_DayMenuSpecification_js-node_modules_react-day-picker_lib_style_css":"a5134908db7ebb005a2d"}[chunkId] + ".css";
};